import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import Indicator from './components/Indicator';
import { ImagesPropType, TextAlignPropType } from '../../services/proptypes';
import { getImageKey } from '../../utils/images';
import './IndicatorGroup.css';
var defaultProps = {
  align: 'center'
};
export default function IndicatorGroup(_ref) {
  var items = _ref.items,
    currentIndex = _ref.currentIndex,
    changeCurrentIndex = _ref.changeCurrentIndex,
    align = _ref.align;
  if (_isEmpty(items) || items.length <= 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "indicator-group ".concat(align)
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Indicator, {
      key: getImageKey(item),
      index: index,
      currentIndex: currentIndex,
      changeCurrentIndex: changeCurrentIndex
    });
  }));
}
IndicatorGroup.defaultProps = defaultProps;